import { Link } from 'omni-package-react-core';
import styled from 'styled-components';

export const StyledLink = styled(Link)`
  font-weight: 600;
  padding-bottom: 36px;
  &:hover {
    text-decoration: underline;
  }
  &:active {
    color: ${({ theme }) => theme.colors.blue10};
    text-decoration: underline;
  }
`;
